import type { ComputedRef, Ref } from 'vue'
import type { UIBreakpoint } from '../types'
import { useCoreConfig } from './useCoreConfig'
import { computed, unref, useBreakpoints, useWindowSize } from '#imports'

export interface UseDisplayReturn {
    breakpoints: ComputedRef<{
        xs: boolean
        sm: boolean
        md: boolean
        lg: boolean
        xl: boolean
        mobile: boolean
        current: UIBreakpoint[]
        isSmaller(k: UIBreakpoint): boolean
        isSmallerOrEqual(k: UIBreakpoint): boolean
        isGreater(k: UIBreakpoint): boolean
        isGreaterOrEqual(k: UIBreakpoint): boolean
        isInBetween(a: UIBreakpoint, b: UIBreakpoint): boolean
    }>
    width: Ref<number>
    height: Ref<number>
}
/**
 * Access display data
 */
export const useDisplay = (): UseDisplayReturn => {
    const config = useCoreConfig()
    const breakpoints = useBreakpoints<UIBreakpoint>({
        xs: config.breakpoints.xs as number,
        sm: config.breakpoints.sm as number,
        md: config.breakpoints.md as number,
        lg: config.breakpoints.lg as number,
        xl: config.breakpoints.xl as number,
    })
    const currentBreakpoint = breakpoints.current() as ComputedRef<UIBreakpoint[]>
    const { width, height } = useWindowSize()

    return {
        // Breakpoints
        breakpoints: computed(() => {
            return {
                xs: unref(breakpoints.xs),
                sm: unref(breakpoints.sm),
                md: unref(breakpoints.md),
                lg: unref(breakpoints.lg),
                xl: unref(breakpoints.xl),
                mobile: breakpoints.isSmallerOrEqual(config.breakpoints.mobileBreakpoint as UIBreakpoint),
                current: unref(currentBreakpoint),
                isSmaller: breakpoints.isSmaller,
                isSmallerOrEqual: breakpoints.isSmallerOrEqual,
                isGreater: breakpoints.isGreater,
                isGreaterOrEqual: breakpoints.isGreaterOrEqual,
                isInBetween: breakpoints.isInBetween,
            }
        }),
        // Window size
        width,
        height,
    }
}
